import apiUtilsService from '@/services/api/utils/utilsService';

export default {
  async getCountries({ commit }) {
    const countries = await apiUtilsService.getCountries();
    commit('setCountries', countries);
  },
};
